/* eslint-disable react-hooks/rules-of-hooks */
import {View, Text, StyleSheet} from 'react-native';
import React from 'react';
import {Document, Page, pdfjs} from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import './index.css';
import {appBackground} from '../../utils/utils';
import logger from '../../utils/logger';

export function readPDF(props) {
   const [numPages, setNumPages] = React.useState(null);
   const [pageNumber, setPageNumber] = React.useState(1);
   const {urlPath} = props;
   const bgColor = props.bgColor ?? appBackground;
   logger('readPDF props', {props});
   function onDocumentLoadSuccess({numPages}) {
      setNumPages(numPages);
      props.loading(false);
      logger('readPDF', {numPages});
   }
   function onLoadError(err) {
      props.loading(false);
      logger('readPDF', {err});
   }

   const CustomLoader = () => {
      return (
         <div className="custom-loader">
            {/* Your custom loader content goes here */}
         </div>
      );
   };

   return (
      <View style={[styles.container, {backgroundColor: bgColor}]}>
         <Document
            file={urlPath}
            loading={<CustomLoader />}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={onLoadError}
            width="1095"
            height="841"
            className="readPDF">
            {Array.apply(null, Array(numPages))
               .map((x, i) => i + 1)
               .map((page, i) => (
                  <Page key={i} pageNumber={page} />
               ))}
         </Document>
      </View>
   );
}
const styles = StyleSheet.create({
   container: {
      //flex: 1,
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      marginVertical: 30,
      backgroundColor: appBackground,
   },
   pdf: {
      /* width: 1095,
      height: 841,
      marginTop: 136, */
   },
   text: {
      color: '#CCC',
      display: 'none',
   },
});
export default readPDF;
